import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { isFeatureOn } from '../../../utils/featureUtils';
import { FEATURE_FLAGS } from '../../../constants/featureFlags';
import hasModification from '../../../assets/img/gantt/activity-has-modifications.png';
import hasNotModification from '../../../assets/img/gantt/activity-has-not-modifications.png';
import requestModificationHover from '../../../assets/img/gantt/request-new-hover.png';
import { textEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { columnCache } from '../../../services/columnCache';

const textCol = (gantt, t) => {
  const name = 'text';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.activities', 'Actividades'),
    width: '270',
    resize: true,
    tree: true,
    editor: textEditor,
    hide: !isVisible,
    data_type: 'string',
    groupable: false,
    orderable: false,
    orderable_switch: ['A → Z', 'Z → A'],
    filterable: true,
    template: (activity) => {
      const hasChild = gantt.hasChild(activity.id);
      let isOdd = gantt.oddColsConfig?.text || false;

      let iconToModifications;
      const onWaiting = activity.activityModifications?.filter(
        (el) => el.state == 'waiting'
      );

      if (onWaiting?.length) {
        iconToModifications = hasModification;
      } else if (activity.activityModifications?.length) {
        iconToModifications = hasNotModification;
      }

      const level = activity.$level;
      const RIGHT_ALIGN = 15 * level;
      const htmlH = getStringHidden(activity.text, 'text', -27);
      const isMRDrawerFeatureEnabled = isFeatureOn(
        FEATURE_FLAGS.ENABLE_MODIFICATION_REQUESTS_DRAWER
      );
      const popoverOpeningHandler = isMRDrawerFeatureEnabled
        ? ''
        : `onclick="window.to_use_react_gantt.$showDropdown(this, ${activity.id})"`;

      let textToRender = `<span class="string-v">${activity.text}</span>`;
      const isSel = gantt.isSelectedTask(activity.id);

      if (
        (['task', 'milestone'].includes(activity.type) ||
          (!activity.type && activity.proplannerId)) &&
        isSel
      ) {
        textToRender = `<span class="string-v">
                                      ${activity.text}
                                  </span>
                              </span>
                              `;
      }

      const modificationIconHtml = iconToModifications
        ? `
          <span class="gantt-dropdown open-mr-drawer-button" style="left: -${RIGHT_ALIGN}px" data-activity-id="${activity.id}" ${popoverOpeningHandler}>
              <Tooltip placement='top' title='${t('lookahead_planification_modification_request')}'>
                  <img class="request-empty-gantt"  width="15" src="${iconToModifications}"/>
                  <img class="request-hover-gantt"  width="15" src="${requestModificationHover}"/>
              </Tooltip>
          </span>`
        : '';

      const result = `
          <div class="${isOdd ? 'odd-col' : 'non-odd-col'} request-btn-task-gantt" style="width: 88%;">
              <span style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
              color: #121212;">
                  <span class="cut-text-and-dot ${iconToModifications ? 'fix-name-at-new-gantt' : ''}">
                      ${textToRender}
                      ${htmlH}
                  </span>
                  ${modificationIconHtml}
              </span>
          </div>
          `;

      
      return result;
    },
  };
};

export default textCol; 